import * as default_data from '../config.js'
import { MenuItem, Select, useTheme } from "@mui/material";

export const getChipColor = (classification = '') => {
  if(classification === undefined || classification === null) {
    return '#3f7a47'; // default color for unclassified
  }
  
  switch (classification.toLowerCase()) {
    case 'cui':
      return '#502b85';
    case 'secret':
      return '#c8102e';
    case 'top secret':
      return '#ff8c00';
    case 'ts/sci':
      return '#fce83a';
    default:
      return '#3f7a47';   // fallback
  }
};

export const getBannerColor = (CUIAuth) => {
    if(default_data.default_classification_level === 'cui') {
        if(CUIAuth) {
            return 'header-message-cui'
        }
        else {
            return 'header-message-unclassified'
        }
    }
    else if(default_data.default_classification_level === 'secret') {
        return 'header-message-secret'
    }
    else if(default_data.default_classification_level === 'topsecret') {
        return 'header-message-topsecret'
    }
    else if(default_data.default_classification_level === 'tssci') {
        return 'header-message-tssci'
    }
    else {
        return 'header-message-unclassified'
    }
}

// React code to display a select menu that goes from 0.0 to 1 with 1 decimal increment and default to 0.0
export const SelectClassification = ({value, onChange, fullWidth=false}) => {
  const theme = useTheme();
  const options = default_data.default_allowed_classifications.map((classification) => (
    <MenuItem key={classification} value={classification} sx={{fontSize: 13}}>
      {classification}
    </MenuItem>
  ));
  
  return (
    <Select
      value={value}
      onChange={onChange}
      defaultValue={default_data.default_allowed_classifications[0]}
      style={{
        width: fullWidth ? '100%' : '200px',
        backgroundColor: theme.palette.dropdowns.backgroundColor,
      }} 
      size="small"
    >
      {options}
    </Select>
  );
};